import {createAction} from "@reduxjs/toolkit";

export const resetAppState = createAction("app/RESET_APP_STATE", (value) => {
  return {
    payload: { value },
  };
});

export const setApiError = createAction(
  "app/SET_API_ERROR",
  (value) => {
    return {
      payload: { value },
    };
  }
);

export const setRemainingCredits = createAction(
  "app/SET_REMAINING_CREDITS",
  (value) => {
    return {
      payload: { value },
    };
  }
);